import { render, staticRenderFns } from "./ReportImageCockpit.vue?vue&type=template&id=145d36a0&"
import script from "./ReportImageCockpit.vue?vue&type=script&lang=ts&"
export * from "./ReportImageCockpit.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageCockpit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports